import { ListItemIcon, ListItemText, MenuItem, Typography } from '@mui/material'
import { useMixerMenuItem, useTunerMenuItem } from '@tunasong/audio-ui'
import { ElectricGuitar, Fretboard, MusicNote } from '@tunasong/icons'
import { useKeyboardMenuItem } from '@tunasong/music-ui'
import type { Entity, Persisted } from '@tunasong/schemas'
import { useNavigate } from '@tunasong/ui-lib'
import { type FC } from 'react'

export interface ToolsMenuItemsProps {
  entity?: Persisted<Entity>
  onClose?: () => void
}

export const ToolsMenuItems: FC<ToolsMenuItemsProps> = props => {
  const { onClose } = props

  const { dialog: mixerDialog, menuItem: mixerMenuItem } = useMixerMenuItem({
    variant: 'caption',
    onClose,
  })
  const { dialog: tunerDialog, menuItem: tunerMenuItem } = useTunerMenuItem({ variant: 'caption', onClose })
  const { dialog: keyboardDialog, menuItem: keyboardMenuItem } = useKeyboardMenuItem({
    variant: 'caption',
    onClose,
  })

  const navigate = useNavigate()

  return (
    <>
      {mixerMenuItem}
      {tunerMenuItem}
      {keyboardMenuItem}

      <MenuItem onClick={() => navigate('/app/guitarchords')}>
        <ListItemIcon sx={{ color: 'inherit' }}>
          <ElectricGuitar />
        </ListItemIcon>
        <ListItemText>
          <Typography variant="caption">Guitar Chords</Typography>
        </ListItemText>
      </MenuItem>
      <MenuItem onClick={() => navigate('/app/guitarpatterns')}>
        <ListItemIcon sx={{ color: 'inherit' }}>
          <Fretboard />
        </ListItemIcon>
        <ListItemText>
          <Typography variant="caption">Guitar Patterns</Typography>
        </ListItemText>
      </MenuItem>
      <MenuItem onClick={() => navigate('/app/theory')}>
        <ListItemIcon sx={{ color: 'inherit' }}>
          <MusicNote />
        </ListItemIcon>
        <ListItemText>
          <Typography variant="caption">Music Theory</Typography>
        </ListItemText>
      </MenuItem>

      {mixerDialog}
      {tunerDialog}
      {keyboardDialog}
    </>
  )
}
